export const isUserLoggedIn = () => {
  return localStorage.getItem('logged') && localStorage.getItem('token');
};

export const getUserAvatar = () => localStorage.getItem('avatar');

export const getUserId = () => localStorage.getItem('id');
